export default __webpack_public_path__ + "static/media/maybank-cards.40ba2f1b.svg";